import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=2e79a702&scoped=true&lang=pug"
import script from "./Arrivals.vue?vue&type=script&lang=js"
export * from "./Arrivals.vue?vue&type=script&lang=js"
import style0 from "./Arrivals.vue?vue&type=style&index=0&id=2e79a702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79a702",
  null
  
)

export default component.exports